// eslint-disable-next-line wandb/no-deprecated-imports
import styled from 'styled-components';

export const CenteredFlex = styled.div`
  display: flex;
  align-items: center;
`;
CenteredFlex.displayName = 'S.CenteredFlex';

export const Value = styled.div`
  font-weight: 600;
  font-size: 24px;
  line-height: 32px;
`;
Value.displayName = 'S.Value';

export const Input = styled.input`
  font-family: inherit;
`;
